module.exports = __webpack_public_path__ + "img/old-structure-organization.b57cbc16.jpg";